<template>
  <div class="access-page" dir="rtl">
    <panel
      Title="دسترسی منوها"
      Des="در این منو می‌توانید دسترسی کاربران به بخش های مختلف را کنترل کنید. همچنین می‌توانید نام نمایش داده شده در منو را تغییر دهید."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>

    <div class="access-page__body">
      <div
        ref="anchor"
        class="access-toolbar-anchor"
        :style="toolbarPinned ? { height: toolbarHeight + 'px' } : null"
      >
        <div ref="sentinel" class="access-sentinel" aria-hidden="true"></div>
        <div
          class="access-toolbar"
          :class="{
            'is-editing': EditMode,
            'is-fixed': toolbarPinned,
          }"
          :style="toolbarPinned ? pinStyle : null"
        >
          <div class="access-summary">
            <template v-if="hasSearch">
              <span>{{ filteredMenu.length }} نتیجه</span>
            </template>
            <template v-else>
              <span>{{ Menu.length }} منو</span>
              <span class="access-summary__sep" aria-hidden="true"></span>
              <span>{{ activeCount }} فعال</span>
            </template>
          </div>
          <label class="access-search">
            <i class="fas fa-search" aria-hidden="true"></i>
            <input
              v-model="searchQuery"
              type="text"
              placeholder="جستجوی نام منو"
              aria-label="جستجوی نام منو"
              autocomplete="off"
            />
            <button
              v-if="hasSearch"
              type="button"
              class="access-search__clear"
              aria-label="پاک کردن جستجو"
              @click="searchQuery = ''"
            >
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </label>
          <div class="access-actions">
            <template v-if="EditMode">
              <button
                type="button"
                class="access-btn access-btn--ghost"
                :disabled="$store.state.loading"
                @click="cancelEdit"
              >
                انصراف
              </button>
              <button
                type="button"
                class="access-btn access-btn--save"
                :disabled="$store.state.loading"
                @click="updatemenu"
              >
                <i class="fas fa-check" aria-hidden="true"></i>
                ثبت اطلاعات
              </button>
            </template>
            <button
              v-else
              type="button"
              class="access-btn access-btn--edit"
              :disabled="!loaded || Menu.length === 0"
              @click="startEdit"
            >
              <i class="fas fa-edit" aria-hidden="true"></i>
              اصلاح
            </button>
          </div>
        </div>
      </div>

      <net-pa-card>
        <template slot="header">
          <h6 class="text-right">
            <i class="fas fa-key"></i>
            فهرست دسترسی منوها
          </h6>
        </template>
        <template slot="content">
          <p v-if="!loaded" class="access-empty">در حال دریافت منوها...</p>
          <p v-else-if="Menu.length === 0" class="access-empty">
            منویی برای نمایش وجود ندارد.
          </p>
          <p v-else-if="filteredMenu.length === 0" class="access-empty">
            منویی با این عبارت پیدا نشد.
          </p>
          <div v-else class="access-list" role="table" aria-label="دسترسی منوها">
            <div class="access-row access-row--head" role="row">
              <span class="access-index-col" role="columnheader">ردیف</span>
              <span aria-hidden="true"></span>
              <span role="columnheader">نام منو</span>
              <span class="access-control-col" role="columnheader">دسترسی</span>
            </div>
            <div
              v-for="row in filteredMenu"
              :key="row.item.id != null ? row.item.id : row.index"
              class="access-row"
              role="row"
              :class="{
                'is-off': !row.item.isMenu,
                'is-locked': row.index === 0,
                'is-editing': EditMode,
              }"
            >
              <span class="access-index" role="cell">{{ row.index + 1 }}</span>
              <span class="access-icon" role="cell" aria-hidden="true">
                <span class="access-bullet"></span>
              </span>
              <div class="access-name" role="cell">
                <input
                  v-if="EditMode"
                  type="text"
                  v-model="row.item.name"
                  :aria-label="'نام منو ' + (row.index + 1)"
                />
                <span v-else>{{ row.item.name }}</span>
              </div>
              <div class="access-control" role="cell">
                <span
                  v-if="row.index === 0"
                  class="access-lock"
                  title="دسترسی این منو قابل تغییر نیست"
                >
                  <i class="fas fa-lock" aria-hidden="true"></i>
                </span>
                <span
                  class="access-state"
                  :class="row.item.isMenu ? 'is-on' : 'is-off'"
                >
                  {{ row.item.isMenu ? "فعال" : "غیرفعال" }}
                </span>
                <label
                  class="access-switch"
                  :class="{ 'is-disabled': row.index === 0 || !EditMode }"
                >
                  <input
                    type="checkbox"
                    v-model="row.item.isMenu"
                    :disabled="row.index === 0 || !EditMode"
                    :aria-label="'دسترسی ' + row.item.name"
                  />
                  <span class="access-switch__track" aria-hidden="true"></span>
                </label>
              </div>
            </div>
          </div>
        </template>
      </net-pa-card>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";

export default {
  components: { NetPaCard, Panel },
  data() {
    return {
      Menu: [],
      EditMode: false,
      loaded: false,
      menuSnapshot: null,
      toolbarPinned: false,
      toolbarHeight: 0,
      pinStyle: null,
      searchQuery: "",
    };
  },
  computed: {
    activeCount() {
      return this.Menu.filter((item) => item && item.isMenu).length;
    },
    hasSearch() {
      return this.normalizeSearch(this.searchQuery).length > 0;
    },
    filteredMenu() {
      var query = this.normalizeSearch(this.searchQuery);
      return this.Menu.map(function (item, index) {
        return { item: item, index: index };
      }).filter(
        function (row) {
          if (!query) return true;
          return this.normalizeSearch(row.item && row.item.name).indexOf(query) !== -1;
        }.bind(this),
      );
    },
  },
  methods: {
    normalizeSearch(value) {
      return String(value || "")
        .replace(/ي/g, "ی")
        .replace(/ك/g, "ک")
        .replace(/ة/g, "ه")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    },
    startEdit() {
      this.menuSnapshot = JSON.parse(JSON.stringify(this.Menu));
      this.EditMode = true;
    },
    cancelEdit() {
      if (this.menuSnapshot) {
        this.Menu = JSON.parse(JSON.stringify(this.menuSnapshot));
      }
      this.EditMode = false;
    },
    readMenus() {
      var DataAxiosRead = {
        ArryfildValue: {},
        Method: "Post",
        Action: "Menu/getAllmenus",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxiosRead)
        .then((data) => {
          this.Menu = data || [];
          this.loaded = true;
        })
        .catch(() => {
          this.Menu = [];
          this.loaded = true;
        });
    },
    updatemenu() {
      this.$store.state.loading = true;
      var DataAxiosUpdate = {
        ArryfildValue: {},
        Method: "Post",
        Action: "Menu/Updatemenus",
        Token: this.$session.get("TokenNetPa"),
      };
      var formdata = new FormData();
      formdata.append("listMenu", JSON.stringify(this.Menu));
      DataAxiosUpdate.ArryfildValue = formdata;
      this.$PostFormData(DataAxiosUpdate).then((data) => {
        this.$store.state.loading = false;
        if (data.status == "OK") {
          this.$mySweetDefault(
            "عملیات موفق!",
            "تغییرات با موفقیت ذخیره شد. برای اعمال یکبار از برنامه خارج شوید و دوباره وارد شوید",
            "success",
            2000,
          );
        } else {
          this.$mySweetDefault(
            "خطا!",
            "در ثبت اطلاعات مشکلی رخ داده است. لطفا دوباره تلاش کنید",
            "danger",
            2000,
          );
        }
        this.EditMode = !this.EditMode;
        this.ClearCashMemoryServer();
      });
    },
    ClearCashMemoryServer() {
      var DataAxiosClearCash = {
        ArryfildValue: {},
        Method: "Post",
        Action: "Menu/ClearCashMemory",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(DataAxiosClearCash).then((data) => {
        if (data == true) {
          this.readMenus();
        } else {
          this.$mySweetDefault(
            "عدم به روز رسانی حافظه",
            "در خالی کردن حافظه موقت سرور مشکلی پیش آمده .",
            "warning",
            2000,
          );
        }
      });
    },
    observeToolbar() {
      if (typeof IntersectionObserver === "undefined" || !this.$refs.sentinel) {
        return;
      }
      this.toolbarObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const shouldPin =
            !entry.isIntersecting && entry.boundingClientRect.top < 8;
          if (shouldPin === this.toolbarPinned) {
            if (shouldPin) this.updatePinBox();
            return;
          }
          if (shouldPin) this.updatePinBox();
          this.toolbarPinned = shouldPin;
        },
        { threshold: 0 },
      );
      this.toolbarObserver.observe(this.$refs.sentinel);
      if (typeof ResizeObserver !== "undefined" && this.$refs.anchor) {
        this.anchorResizeObserver = new ResizeObserver(() => {
          if (this.toolbarPinned) this.updatePinBox();
        });
        this.anchorResizeObserver.observe(this.$refs.anchor);
      }
    },
    updatePinBox() {
      const anchor = this.$refs.anchor;
      const toolbar = anchor && anchor.querySelector(".access-toolbar");
      if (!anchor || !toolbar) return;
      const rect = anchor.getBoundingClientRect();
      this.toolbarHeight = toolbar.offsetHeight;
      this.pinStyle = {
        top: "12px",
        left: rect.left + "px",
        width: rect.width + "px",
      };
    },
  },
  created() {
    this.readMenus();
  },
  mounted() {
    this.$nextTick(() => {
      const toolbar =
        this.$refs.anchor && this.$refs.anchor.querySelector(".access-toolbar");
      if (toolbar) this.toolbarHeight = toolbar.offsetHeight;
      this.observeToolbar();
    });
  },
  beforeDestroy() {
    if (this.toolbarObserver) this.toolbarObserver.disconnect();
    if (this.anchorResizeObserver) this.anchorResizeObserver.disconnect();
  },
};
</script>
<style scoped>
.access-page__body {
  max-width: 920px;
  margin: 0 auto;
  padding: 0 8px 28px;
}

.access-toolbar-anchor {
  margin-bottom: 12px;
}

.access-sentinel {
  height: 1px;
  margin: 0;
  pointer-events: none;
}

.access-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #dbe5eb;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 5px 18px rgba(31, 42, 79, 0.08);
}

.access-toolbar.is-editing {
  border-color: rgba(5, 184, 200, 0.35);
  background: linear-gradient(100deg, rgba(237, 247, 251, 0.98), #fff 62%);
}

.access-toolbar.is-fixed {
  position: fixed;
  z-index: 40;
  margin-bottom: 0;
  box-shadow: 0 14px 28px rgba(41, 52, 95, 0.16);
}

.access-summary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #31465f;
  font-size: 13px;
  font-weight: 700;
}

.access-summary__sep {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #05b8c8;
}

.access-search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 200px;
  min-width: 160px;
  height: 40px;
  margin: 0;
  padding: 0 12px;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #f7f9fb;
}

.access-search:focus-within {
  border-color: #05b8c8;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.access-search > i {
  flex: 0 0 auto;
  color: #8091a3;
  font-size: 13px;
}

.access-search input {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0;
  color: #4d6072;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  border: 0;
  background: transparent;
}

.access-search input:focus {
  outline: none;
}

.access-search input::placeholder {
  color: #8b98a8;
  font-weight: 500;
}

.access-search__clear {
  display: grid;
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  padding: 0;
  color: #8091a3;
  place-items: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
}

.access-search__clear:hover {
  color: #596a7d;
  background: rgba(89, 106, 125, 0.08);
}

.access-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.access-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 16px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  border-radius: 12px;
  cursor: pointer;
  transition:
    color 180ms ease,
    background 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease,
    transform 180ms ease;
}

.access-btn:focus {
  outline: none;
}

.access-btn:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.22);
}

.access-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.access-btn--edit,
.access-btn--ghost {
  color: #29345f;
  border: 1px solid #dbe5eb;
  background: #fff;
}

.access-btn--edit:not(:disabled):hover,
.access-btn--ghost:not(:disabled):hover {
  color: #8d58a4;
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

.access-btn--save {
  min-height: 44px;
  padding: 10px 18px;
  color: #fff;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 10px 20px rgba(41, 52, 95, 0.16);
}

.access-btn--save:not(:disabled):hover {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(41, 52, 95, 0.22);
}

.access-list {
  display: flex;
  flex-direction: column;
}

.access-row {
  display: grid;
  grid-template-columns: 40px 22px minmax(0, 1fr) max-content;
  align-items: center;
  gap: 12px;
  min-height: 58px;
  padding: 8px 4px;
  border-bottom: 1px solid #e8eef2;
}

.access-row:last-child {
  border-bottom: 0;
}

.access-row--head {
  min-height: 36px;
  padding-top: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.access-index-col,
.access-control-col {
  white-space: nowrap;
}

.access-index-col {
  font-size: 11px;
  text-align: center;
}

.access-index {
  display: grid;
  justify-self: center;
  width: 28px;
  height: 28px;
  place-items: center;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
  border-radius: 8px;
  background: #f5f7fb;
}

.access-icon {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  color: #8091a3;
  font-size: 15px;
  line-height: 1;
}

.access-bullet {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #b7c3ce;
}

.access-row.is-off .access-bullet {
  background: #c9d2da;
}

.access-name {
  min-width: 0;
  color: #596a7d;
  font-size: 13px;
  font-weight: 600;
}

.access-name span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.access-row.is-off .access-name {
  color: #8b98a8;
  font-weight: 500;
}

.access-name input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  color: #4d6072;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
}

.access-name input:focus {
  outline: none;
  border-color: #05b8c8;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.access-control {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.access-lock {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  color: #8b98a8;
  font-size: 11px;
}

.access-state {
  min-width: 52px;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.access-state.is-on {
  color: #068997;
}

.access-state.is-off {
  color: #8b98a8;
}

.access-switch {
  position: relative;
  display: inline-flex;
  margin: 0;
  cursor: pointer;
}

.access-switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
}

.access-switch__track {
  position: relative;
  display: block;
  width: 44px;
  height: 26px;
  border-radius: 999px;
  background: #d5dee6;
  transition: background 180ms ease;
}

.access-switch__track::after {
  content: "";
  position: absolute;
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(19, 36, 58, 0.22);
  transition: transform 180ms ease;
}

.access-switch input:checked + .access-switch__track {
  background: linear-gradient(110deg, #29345f, #05b8c8);
}

.access-switch input:checked + .access-switch__track::after {
  transform: translateX(-18px);
}

.access-switch input:focus-visible + .access-switch__track {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.22);
}

.access-switch input:disabled + .access-switch__track {
  cursor: not-allowed;
  opacity: 0.55;
}

.access-switch.is-disabled {
  cursor: not-allowed;
}

.access-empty {
  margin: 8px 0 4px;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}

@media (max-width: 767px) {
  .access-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .access-search {
    flex: 1 1 100%;
    order: -1;
    min-width: 0;
  }

  .access-actions {
    width: 100%;
  }

  .access-btn--edit,
  .access-btn--ghost,
  .access-btn--save {
    flex: 1;
  }

  .access-row {
    grid-template-columns: max-content 22px minmax(0, 1fr);
    gap: 10px;
  }

  .access-control {
    grid-column: 1 / -1;
    justify-self: end;
  }

  .access-row--head .access-control-col {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .access-btn,
  .access-switch__track,
  .access-switch__track::after {
    transition: none;
  }

  .access-btn--save:not(:disabled):hover {
    transform: none;
  }
}
</style>
